import React from 'react';

const styles = {
  footer: {
    padding: 5,
    textAlign: 'center',
    fontSize: '14px',
  },
};

const Footer = () => {
  return (
    <div style={styles.footer}>
      <p>
        Not affiliated with Valve Corporation or Steam.</p>
      <p>
        All containers, items, and images shown on our site are the exclusive property of Valve Corporation. We do not
        guarantee the accuracy of probability calculations, as Valve Corporation controls all unboxing odds. Users are
        solely responsible for any decisions made based on the information provided on our site.
      </p>
      <p>marketdb.github.io</p>
    </div>
  );
}

export default Footer;
